import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPrinter, FiDownload } = FiIcons;

const PrintButton = ({ language }) => {
  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = 'https://chatbot-n8n-deck.99ssc.app/images/resume/ResumeNutthakorn.pdf';
    link.download = 'ResumeNutthakorn.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 print:hidden">
      <motion.button
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        onClick={handleDownload}
        className="bg-gradient-to-r from-stone-600 to-stone-700 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 group"
        title={language === 'en' ? 'Download Resume' : 'ดาวน์โหลดเรซูเม่'}
      >
        <SafeIcon icon={FiDownload} className="text-2xl" />
      </motion.button>
      
      <motion.button
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3, delay: 0.1 }}
        onClick={handlePrint}
        className="bg-gradient-to-r from-amber-600 to-amber-700 text-white p-4 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110"
        title={language === 'en' ? 'Print Resume' : 'พิมพ์เรซูเม่'}
      >
        <SafeIcon icon={FiPrinter} className="text-2xl" />
      </motion.button>
    </div>
  );
};

export default PrintButton;